import { ButtonHTMLAttributes, ReactNode, useRef } from 'react';

import Button from '~components/Button';
import CloseIcon from '~components/Icon/CloseIcon';
import ModalBase, { ModalBaseProps } from '~components/ModalBase';

import { S } from './style';

interface ModalProps extends ModalBaseProps {
  title: ReactNode;
  content: ReactNode;
  confirmButtonText: string;
  handleConfirm: (value: unknown) => void;
  cancelButtonText?: string;
  handleCancel?: (value: unknown) => void;
  confirmButtonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

function ContentModal({
  isOpen,
  handleClose,
  title,
  content,
  handleConfirm,
  handleCancel,
  confirmButtonText,
  cancelButtonText,
  confirmButtonProps,
}: ModalProps) {
  return (
    <ModalBase isOpen={isOpen} handleClose={handleClose} inlineCss={S.Base} hasCloseButton>
      <S.Title>{title}</S.Title>
      <S.Content>{content}</S.Content>
      <S.ButtonGroup>
        {cancelButtonText && handleCancel && (
          <Button variant='light' size='lg' onClick={handleCancel}>
            {cancelButtonText}
          </Button>
        )}
        <Button variant='dark' size='lg' onClick={handleConfirm} {...confirmButtonProps}>
          {confirmButtonText}
        </Button>
      </S.ButtonGroup>
    </ModalBase>
  );
}

export default ContentModal;
